<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swal from "sweetalert2";
import router from "@/router";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: "LoginPage",
  components: {LoadingPage},
  setup(){

    var loading = ref(false)
    var phone = ref('');
    let check_privacy = ref(false)


    function send_code() {
      if(phone.value.length != 11 || phone.value.charAt(0) != '0' || phone.value.charAt(1) != '9' ){

        Swal.fire({
          icon:'warning',
          title: 'لطفا شماره تماس خود را به صورت صحیح وارد کنید.',
          confirmButtonText: 'متوجه شدم',
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
      }else if (!check_privacy.value){

        Swal.fire({
          icon:'warning',
          title: 'پذیرفتن شرایط و قوانین برای ورود به اپلیکیشن الزامی است.',
          confirmButtonText: 'متوجه شدم',
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      } else {

        loading.value = true
       FreeWorld.Heisenberg({action:'phone', phone:phone.value,} , 'otp').then((result)=>{
          loading.value = false
          var res = result.data

          if (res.status === 'ok'){
            router.push({name:"OtpPage",params:{phone:phone.value}})
          }else if (res.event === 'user is block' ){

            Swal.fire({
              text: "متاسفانه پروفایل شما توسط مدیریت مسدود شده است!",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "متوجه شدم",
              allowOutsideClick:false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            })

          }else {
            Swal.fire({
              icon:'error',
              title: 'متاسفانه مشکلی رخ داده است',
              confirmButtonText: 'متوجه شدم',
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            })
          }

        }).catch((result)=>{
          loading.value = false
         Swals.Catch(result , send_code)
        })



      }
    }


    return{
      loading,
      send_code,
      phone,
      check_privacy,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="animate__animated animate__fadeIn position-relative">
    <img class="bg-login" src="../assets/img/bg-login.png" alt="" />
    <div class="w-100 position-relative">
      <br>
      <br>
      <br>
      <br>
      <img class="img-logo d-block mx-auto mb-5" src="../assets/img/logo_app.svg" alt=""/>
      <img style="height: 50px" class="d-block mx-auto" src="../assets/img/logo_splash.png" alt=""/>
    </div>
    <br>
    <br>
    <div class="div-blur p-4 d-block mx-auto">
      <br>
      <br>
      <br>
      <p class="font-3  text-white text-center">
        جهت ورود لطفا شماره همراه خود را وارد کنید
      </p>
      <br>
      <div class="d-flex position-relative">

        <input
            autofocus
            v-model="phone"
            id="phone_number"
            class="input-number rounded-pill d-block mx-auto font-5 py-1 bg-white"
            type="tel"
            placeholder="شماره همراه"
            onkeydown="return event.key != ' ' "
            maxlength="11"
        />
        <!-- <div class=""> -->
        <img class="icon-phone " src="../assets/img/icon-phone.svg" alt="" />
        <!-- </div> -->
      </div>
      <!-- == -->
      <div>
        <!-- <v-checkbox label="Checkbox"></v-checkbox> -->
      </div>
      <!-- == -->
      <div class="d-flex align-items-center  mt-4 mb-3 justify-content-center ">
        <input v-model="check_privacy" id="privacy_input" class="font-color  mx-1 " type="checkbox" />
        <label class="font-6  text-dark mx-1 text-center" for="phone_number">تمام
          <router-link :to="{name:'RulesPage',params:{action:'ruls'}}" class="text-decoration-underline text-dark mx-1">شرایط و قوانین </router-link>برنامه
          و
          <router-link :to="{name:'RulesPage',params:{action:'privicy'}}" class="text-decoration-underline  text-dark mx-1">حریم خصوصی </router-link>
          را می پذیرم
        </label>
      </div>

      <br>
      <br>
      <button
          @click="send_code()"
          class="bg-color shadow-lg text-white btn-number d-block mx-auto rounded font-5"
          type="submit"
      >
        ارسال کد
      </button>
    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="container-fluid animate__animated animate__fadeIn bg-color-holder position-relative">

    <div class="center-y w-100">
    <div class="div-blur p-4 d-block mx-auto p-body">
      <br>

      <p class="font-4 text-white text-center">
        جهت ورود لطفا شماره همراه خود را وارد کنید
      </p>
      <br>
      <div class="d-flex position-relative">

        <input
            autofocus
            v-model="phone"
            id="phone_number"
            class="input-number rounded-pill d-block mx-auto font-5 py-1 bg-white"
            type="tel"
            placeholder="شماره همراه"
            onkeydown="return event.key != ' ' "
            maxlength="11"
        />
        <!-- <div class=""> -->
        <img class="icon-phone " src="../assets/img/icon-phone.svg" alt="" />
        <!-- </div> -->
      </div>
      <!-- == -->
      <div>
        <!-- <v-checkbox label="Checkbox"></v-checkbox> -->
      </div>
      <!-- == -->
      <div class="d-flex align-items-center mt-10 mb-3 justify-content-start ">
        <input v-model="check_privacy" id="privacy_input" class="font-color mx-1 " type="checkbox" />
        <label class="font-5 text-dark mx-1 text-right" for="phone_number">تمام
          <router-link :to="{name:'RulesPage',params:{action:'ruls'}}" class="text-decoration-underline text-dark mx-1">شرایط و قوانین </router-link>برنامه
          و
          <router-link :to="{name:'RulesPage',params:{action:'privicy'}}" class="text-decoration-underline  text-dark mx-1">حریم خصوصی </router-link>
          را می پذیرم
        </label>
      </div>

      <br>
      <br>
      <button
          @click="send_code()"
          class="bg-color shadow-lg text-white btn-number d-block mx-auto rounded font-5"
          type="submit"
      >
        ارسال کد
      </button>
    </div>
    </div>

  </div>

</template>

<style scoped>

.bg-color-holder{
  background-image: linear-gradient(to top,#FFAF73 , #FF9900);
}
.bg-login {
  height: 100dvh;
  position: absolute;
  top: -5px;
  right: -5px;
  width: 103%;
  max-width: 700px;
}
.img-logo {
  height: 10rem;
}
.div-blur {
  background-color: rgba(255, 255, 255, 0.2);
  /* background-color: #1a1222; */
  border-radius: 30px;
  width: 90%;
  max-width: 470px;
  /* filter: blur(1px); */
  /* -webkit-filter: blur(8px); */
  -webkit-backdrop-filter: blur(10px);
  /* opacity: 0.8; */
  top: 20px;
  position: relative;
  /* z-index: 1; */
  backdrop-filter: saturate(1) blur(10px);
  /* backdrop-filter: blur(100px); */
}

.input-number {
  width: 100%;
  line-height: 45px;
  border: none;
  text-align: center;
  /* box-shadow: 0 0 15px rgb(212, 212, 212); */
}
.icon-phone {
  /* height: 53px; */
  width: 49px;
  /* border-radius: 50%; */
  position: absolute;
  text-align: center;
  right: 0;
  top: 50%;
  transform: translate(0% , -48%);
  /* margin: 4px; */
  /* padding: 5px; */
}
.btn-number {
  width: 60%;
  border: none;
  line-height: 40px;
}

</style>